import React from "react";
import "./About.css";
import { Col, Container, Row } from "react-bootstrap";
import Me from "../../assets/me.png";

const About = () => {
  return (
    <Container fluid="md" className="about-section" id="about">
      <Row>
        <Col className="about-img">
          <img src={Me} alt="me" />
        </Col>
        <Col className="about-content">
          <h2>
            <span>About </span> Me
          </h2>
          <p>
            I am a passionate software engineer with a BEng (Hons) in Artificial
            Intelligence and Data Science, graduating with First Class Honors.
            My career began in 2020, and since then, I have been deeply immersed
            in the world of coding, specializing in frontend development and
            machine learning. I have developed several innovative tools and
            models, driven by my enthusiasm for creating impactful software
            solutions. <br/><br/>In addition to my technical expertise, I am an active
            member of the Rotaract Club, where I have led numerous community
            service projects and organized hackathons, furthering my commitment
            to social impact and collaborative innovation.<br/><br/> Beyond my
            professional and academic pursuits, I have a strong athletic
            background. As a three-time athletic champion in school, I was
            honored as the Best Track Athlete in 2019. I also earned recognition
            as a Western Province 1500m finalist and an inter-school athletic
            championship winner. <br/><br/>Driven by a love for coding and a dedication to
            continuous growth, I am eager to embrace new challenges and
            contribute to the success of a forward-thinking organization.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default About;
